// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-discount{padding:7px 8px 8px;color:#fff;font-family:var(--1f4ceo1);font-size:16px;font-weight:400;line-height:16px;text-align:center;border-radius:25px;background-color:#b342ff}@media only screen and (min-width:992px){.product-discount{padding:9px 11px 10px;font-size:20px;line-height:20px}}", ""]);
// Exports
module.exports = exports;
